import React from 'react'

export function Quotation(props) {
  return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" color='black' viewBox="0 0 310 310" {...props}><path d="M288.32 49.87H183.19v210.26L288.32 155zM126.81 155V49.87H21.68v210.26z" fill="#000000"></path></svg>
    )
}
export default Quotation